var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen flex w-full items-center justify-center",class:_vm.getDentalVersionActive ? 'bg-image-dental' : 'bg-image-kuyum'})}
var staticRenderFns = []

export { render, staticRenderFns }